import React, { useEffect } from "react";
import {
  FaHeart,
  FaShoppingCart,
  FaImages,
  FaGraduationCap,
  FaUser,
  FaEnvelope,
  FaQuestionCircle,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  MobileMenuOverlay,
  MobileMenuContainer,
  MobileMenuNav,
  MobileNavLink,
  MobileMenuDivider,
  MobileMenuActions,
  MobileCartButton,
  MobileCTAButton,
  CartBadgeMobile,
} from "./MobileMenu.styles";
import { selectCartTotalItems } from "../../../store/slices/cart/slice";

const MobileMenu = ({ isOpen, onClose, onNavigate, tickerVisible }) => {
  const { pathname } = useLocation();
  const cartCount = useSelector(selectCartTotalItems);

  // Scroll lock
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handleNavigation = (path) => {
    onClose();
    setTimeout(() => {
      onNavigate(path);
    }, 420);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <MobileMenuOverlay $isOpen={isOpen} onClick={handleOverlayClick} />
      <MobileMenuContainer $isOpen={isOpen} $tickerVisible={tickerVisible}>
        <MobileMenuNav>
          <ul>
            <li>
              <MobileNavLink
                $active={pathname === "/galerija"}
                onClick={() => handleNavigation("/galerija")}
              >
                <FaImages />
                Galerija
              </MobileNavLink>
            </li>
            <li>
              <MobileNavLink
                $active={pathname === "/kursevi"}
                onClick={() => handleNavigation("/kursevi")}
              >
                <FaGraduationCap />
                Kursevi
              </MobileNavLink>
            </li>
            <li>
              <MobileNavLink
                $active={pathname === "/o-meni"}
                onClick={() => handleNavigation("/o-meni")}
              >
                <FaUser />O Meni
              </MobileNavLink>
            </li>
            <li>
              <MobileNavLink
                $active={pathname === "/cesta-pitanja"}
                onClick={() => handleNavigation("/cesta-pitanja")}
              >
                <FaQuestionCircle />
                FAQ
              </MobileNavLink>
            </li>
            <li>
              <MobileNavLink
                $active={pathname === "/kontakt"}
                onClick={() => handleNavigation("/kontakt")}
              >
                <FaEnvelope />
                Kontakt
              </MobileNavLink>
            </li>
          </ul>
        </MobileMenuNav>

        <MobileMenuDivider />

        <MobileMenuActions>
          <MobileCartButton onClick={() => handleNavigation("/korpa")}>
            <FaShoppingCart />
            <span>Korpa</span>
            {cartCount > 0 && (
              <CartBadgeMobile>
                {cartCount > 99 ? "99+" : cartCount}
              </CartBadgeMobile>
            )}
          </MobileCartButton>

          <MobileCTAButton onClick={() => handleNavigation("/pristup")}>
            <FaHeart />
            Počni Učenje
          </MobileCTAButton>
        </MobileMenuActions>
      </MobileMenuContainer>
    </>
  );
};

export default MobileMenu;
